<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" v-model="dialog" width="581" scrollable>
    <v-card>
      <v-card-title class="primary white--text text-uppercase">
        Sửa điểm danh xe tuyến
        <v-spacer></v-spacer>
        <v-btn dark icon>
          <v-icon @click="cancel">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-form ref="form" class="py-4">
          <p>Ngày {{ getCurrentDate }}</p>

          <v-row>
            <v-col cols="6" class="pl-1">
              <CardStudentName :student="studentTracking && studentTracking.student" />
            </v-col>
            <v-col class="d-flex justify-space-between align-center" cols="6">
              <div>
                <p class="text-caption my-0">Ngày sinh</p>
                <span>{{ studentTracking.student && studentTracking.student.dob || '' | ddmmyyyy }}</span>
              </div>
              <div>
                <p class="text-caption my-0">Mã số</p>
                <span>{{
                  studentTracking.student && studentTracking.student.code || '' | getStudentCode
                }}</span>
              </div>
              <div>
                <p class="text-caption my-0">Lớp</p>
                <span>{{
                  studentTracking | _get('currentClass.title')
                }}</span>
              </div>
            </v-col>
          </v-row>
          <v-divider class="my-4"></v-divider>

          <v-row class="mt-1">
            <v-col cols="6" class="py-0">
              <div>
                <div class="mb-2">Trạng thái<span class="error--text">*</span></div>
                <v-select
                  v-model="checkinStatus"
                  item-text="title"
                  item-value="value"
                  :items="status"
                  :rules="[$rules.required]"
                  label="Trạng thái lên xe"
                  placeholder="Trạng thái lên xe"
                  dense
                  clearable
                  outlined
                ></v-select>
              </div>
            </v-col>
          </v-row>
          <v-divider class="mb-4"></v-divider>

          <v-row class="mt-6">
            <v-col cols="6" class="py-0">
              <div>
                <div class="mb-2">Giờ lên xe (24h)</div>
                <TimeInput
                  label="Giờ lên xe (24h)"
                  outlined
                  dense
                  class="required"
                  :date.sync="checkIn"
                  :selectedDate="getCurrentDate"
                  :rules="[$rules.required, $rules.time]"
                  v-if="checkinStatus === 'attendance' || checkinStatus === 'left'"
                />
                <v-text-field v-else disabled placeholder="HH:mm" outlined dense></v-text-field>
              </div>
            </v-col>
            <v-col cols="6" class="py-0">
              <div class="mb-2">Giờ xuống xe (24h)</div>
              <div>
                <TimeInput
                  label="Giờ xuống xe (24h)"
                  outlined
                  dense
                  outline
                  :selectedDate="getCurrentDate"
                  :rules="[$rules.required, $rules.time]"
                  :date.sync="checkOut"
                  v-if="checkinStatus === 'left'"
                />
                <v-text-field v-else disabled placeholder="HH:mm" outlined dense></v-text-field>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn class="ma-2" outlined light depressed @click="cancel">Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="ma-2" dark depressed color="#0D47A1" @click="save">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import CardStudentName from '@/components/basic/card/CardStudentName'
import moment from 'moment'
import TimeInput from '@/components/basic/TimeInput.vue'

export default {
  components: {
    CardStudentName,
    TimeInput
  },
  data() {
    return {
      dialog: false,
      currentClass: null,
      studentTracking: {},
      checkIn: '',
      checkOut: '',
      checkinStatus: '',
      status: []
    }
  },
  computed: {
    getCurrentDate() {
      return moment(this.date).format('DD/MM/YYYY')
    }
  },
  methods: {
    ...mapActions('BusStudentAttendance', ['updateStatusAndTimeBusStudentTracking', 'findOneStudentTracking']),

    async save() {
      this.$loading.active = true
      let params = {
        status: this.checkinStatus,
        timeCheckIn: this.checkIn ? new Date(this.checkIn).getTime().toString() : null,
        timeCheckOut: this.checkOut ? new Date(this.checkOut).getTime().toString() : null
      }
      let newStudentTracking = await this.updateStatusAndTimeBusStudentTracking({
        id: this.studentTracking.id,
        params: params
      })
      if (newStudentTracking) this.studentTracking = newStudentTracking
      this.$loading.active = false
    },

    reset() {
      this.$refs.form.reset()
    },
    async openDialog(studentTrackingId) {
      this.$loading.active = true
      let studentTracking = await this.findOneStudentTracking(studentTrackingId)
      this.getStatus(studentTracking.bus_tracking.status)
      this.checkinStatus = studentTracking.status
      this.checkIn = studentTracking.timeCheckIn
        ? new Date(Number.parseInt(studentTracking.timeCheckIn)).toISOString()
        : null
      this.checkOut = studentTracking.timeCheckOut
        ? new Date(Number.parseInt(studentTracking.timeCheckOut)).toISOString()
        : null
      this.studentTracking = studentTracking
      this.$loading.active = false
      this.dialog = true
    },
    cancel() {
      this.dialog = false
    },
    getStatus(statusBusTracking) {
      switch (statusBusTracking) {
        case 'running':
          this.status = [
            {
              title: 'Chưa lên xe',
              value: 'notCheckin'
            },
            {
              title: 'Vắng mặt',
              value: 'absent'
            },
            {
              title: 'Đã lên xe',
              value: 'attendance'
            }
          ]
          break
        case 'pickedup':
          this.status = [
            {
              title: 'Chưa xuống xe',
              value: 'notLeft'
            },
            {
              title: 'Đã xuống xe',
              value: 'left'
            }
          ]
          break
        case 'finished':
          this.status = [
            {
              title: 'Vắng mặt',
              value: 'absent'
            },
            {
              title: 'Đã xuống xe',
              value: 'left'
            }
          ]
      }
    }
  },
  watch: {
    checkinStatus: {
      handler() {
        switch (this.checkinStatus) {
          case 'attendance':
            this.checkIn = this.studentTracking.timeCheckIn
              ? new Date(Number.parseInt(this.studentTracking.timeCheckIn)).toISOString()
              : null
            break
          case 'left':
            this.checkIn = this.studentTracking.timeCheckIn
              ? new Date(Number.parseInt(this.studentTracking.timeCheckIn)).toISOString()
              : null
            this.checkOut = this.studentTracking.timeCheckOut
              ? new Date(Number.parseInt(this.studentTracking.timeCheckOut)).toISOString()
              : null
            break
          default:
            this.checkIn = ''
            this.checkOut = ''
        }
      }
    }
  }
}
</script>
